import React from 'react';
import { AlertTriangle, CircleX, Tag } from 'tabler-icons-react';
import { useCalidad } from './CalidadContext';

export default function CalidadResumen() {
    const { resumen, selectedCorrida } = useCalidad();

    if (!selectedCorrida) return null;

    return (
        <div className="calidad-resumen">
            <div className="calidad-resumen-card">
                <div className="calidad-resumen-card-icon">
                    <CircleX size={20} />
                </div>
                <div className="calidad-resumen-card-text">
                    <span className="calidad-resumen-card-value">{resumen.total}</span>
                    <span className="calidad-resumen-card-label">Piezas scrap</span>
                </div>
            </div>

            <div className="calidad-resumen-card">
                <div className="calidad-resumen-card-icon">
                    <AlertTriangle size={20} />
                </div>
                <div className="calidad-resumen-card-text">
                    <span className="calidad-resumen-card-value">{resumen.defectoLider}</span>
                    <span className="calidad-resumen-card-label">Defecto principal</span>
                </div>
            </div>

            <div className="calidad-resumen-card">
                <div className="calidad-resumen-card-icon">
                    <Tag size={20} />
                </div>
                <div className="calidad-resumen-card-text">
                    <span className="calidad-resumen-card-value">{resumen.unicos}</span>
                    <span className="calidad-resumen-card-label">Tipos de defecto</span>
                </div>
            </div>
        </div>
    );
}
